import type React from "react";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";

import styles from "../VideoPlayer.module.scss";

interface VideoPlayerPosterProps {
  poster: string;
  alt: string;
  title: string;
}

export const VideoPlayerPoster: React.FC<VideoPlayerPosterProps> = ({ poster, alt, title }) => {
  if (!poster.length) return null;

  return (
    <div className={styles.videoPlayerPosterWrapper}>
      <ImageBehaviour data-testid="videoPlayerPoster" alt={alt} title={title} src={poster} />
    </div>
  );
};
